// Includes a mix of active and historical payment methods, to ensure we can properly present old orders (eg. for receipts)
export enum PaymentMethod {
  aeropay = 'aeropay',
  aeropayWhiteLabel = 'aeropay_white_label',
  canpay = 'canpay',
  cash = 'cash',
  credit = 'credit',
  debit = 'debit',
  moneris = 'moneris',
  payfirma = 'payfirma',
  paytender = 'paytender',
  square = 'square',
  stronghold = 'stronghold',
}

const paymentMethodMap: Record<PaymentMethod, string> = {
  [PaymentMethod.aeropay]: 'Aeropay',
  [PaymentMethod.aeropayWhiteLabel]: 'Aeropay',
  [PaymentMethod.canpay]: 'CanPay',
  [PaymentMethod.cash]: 'cash',
  [PaymentMethod.credit]: 'credit',
  [PaymentMethod.debit]: 'debit',
  [PaymentMethod.moneris]: 'Moneris',
  [PaymentMethod.payfirma]: 'Payfirma',
  [PaymentMethod.paytender]: 'Paytender',
  [PaymentMethod.square]: 'Square',
  [PaymentMethod.stronghold]: 'Stronghold',
};

export const formatPaymentMethod = (paymentMethod: string) => {
  return paymentMethodMap[paymentMethod as PaymentMethod] ?? paymentMethod;
};
